import angular from 'angular'

import { wrap, uniqueId } from 'lodash-es'

import envRaw from '../utils/env-raw'

import Template from './gallery-load-more.component.ejs'

angular
  .module('ggs.gallery-load-more')
  .component('ggsGalleryLoadMore', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryLoadMoreComponent,
    bindings: {
      ggsStylerNew: '<',
      ggsProperties: '<',
      ggsShowsButton: '<',
      ggsLoadMoreClickHandler: '<'
    }
  })

const DELAY = 2e3

function GalleryLoadMoreComponent(
  qh,
  $log,
  $scope,
  animate,
  $element,
  StayInQueue,
  DefineHandler,
  DefineMethod,
  GalleryLoadMoreStyleHandlers) {

  const sign = `galleryLoadMore[uid=${uniqueId()}]`
  const $ctrl = $scope.$ctrl = this
  $ctrl.wrapH = DefineHandler(sign)
  $ctrl.wrapM = DefineMethod(sign)

  const stayInQueue = StayInQueue(sign)
  const styleHandlers = GalleryLoadMoreStyleHandlers()

  // $onInit
  $ctrl.wrapM('attachToStyler',
    qh.makeCatch(
      wrap(styleHandlers, $ctrl.ggsStylerNew.reg),
      wrap(`${sign}#attachToStyler: error halted:`, $log.error)))

  $ctrl.wrapH('$onInit',
    $ctrl.attachToStyler)

 // $onDestroy
  $ctrl.wrapH('$onDestroy',
    wrap(styleHandlers, $ctrl.ggsStylerNew.release))

  // show\hide
  animate.hideForce($element)

  $ctrl.wrapM('show',
    animate.makeIfHidden(
      $element,
      animate.showSoft))

  $ctrl.wrapM('hide',
    animate.makeIfVisible(
      $element,
      qh.makeOver(
        animate.hideSoft,
        qh.makeDelay(DELAY),
        animate.hideForce)))

  $ctrl.wrapH('changeHandler',
    stayInQueue.make(
      qh.makeIfElse(
        $ctrl.ggsShowsButton,
        $ctrl.show,
        $ctrl.hide)))

  $scope.$watch(
    $ctrl.ggsShowsButton,
    $ctrl.changeHandler)
}
